import { Component, OnInit } from '@angular/core';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-barmitierra-splashscreen',
  templateUrl: './barmitierra-splashscreen.component.html',
  styleUrls: ['./barmitierra-splashscreen.component.scss']
})
export class BarmitierraSplashscreenComponent implements OnInit {

  constructor() { }
  client = environment.client;


  ngOnInit(): void {
  }
}
